import React from 'react';
import { Link } from 'react-router-dom';
import MLink from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import * as ROUTES from '../utils/routes';
import { SUPER_ADMIN, ADMIN } from '../utils/userRoles';
import ChevronRight from '@material-ui/icons/ChevronRight';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Typography from '@material-ui/core/Typography';
import { useSelector } from 'react-redux';
import { userOrganizationHasFeatureFlag } from '../redux/actions/utils';

import Collapse from '@material-ui/core/Collapse';

export const Navbar = ({ signIn, role, pathname, onAppsClick, appsOpen, onLogout }) => {
    const classes = useStyles();
    const organizations = useSelector((state) => state.data.organizations); // need to watch when this changes for imported userOrganizationHasFeatureFlag() function
    return (
        <Drawer variant="permanent" anchor="left" className={classes.drawer}>
            {signIn ? (
                <Link to={ROUTES.DASHBOARD} style={{ lineHeight: 0 }}>
                    <img src="/topLogo.png" alt="Logo" className={classes.topLogo} />
                </Link>
            ) : (
                ''
            )}
            {signIn ? buttons(role, classes, pathname, onAppsClick, appsOpen, onLogout) : ''}
            {signIn ? (
                <Typography className={classes.bottomLogo}>
                    By using this site and associated apps you agree to the&nbsp;
                    <Link to={ROUTES.TERMS} className={classes.bottomLink}>
                        Terms of Service
                    </Link>{' '}
                    and&nbsp;
                    <MLink href={ROUTES.PRIVACY_POLICY} className={classes.bottomLink} target="_blank">
                        Privacy Policy
                    </MLink>
                </Typography>
            ) : (
                ''
            )}
        </Drawer>
    );
};

/*
Powered By Link

<a
  href="https://www.mightyimmersion.com"
  target="_blank"
  rel="noopener noreferrer"
  className={classes.bottomLink}
>
  <img
    src="/bottomLogo.png"
    alt="Powered By Mighty Immersion"
    className={classes.bottomLogo}
  />        
</a>
*/
const buttons = (role, classes, pathname, onAppsClick, appsOpen, onLogout) => (
    <List className={classes.drawer}>
        {button('Dashboard', ROUTES.DASHBOARD, classes, pathname)}
        {role === SUPER_ADMIN ? button('Analytics', ROUTES.ANALYTICS, classes, pathname) : ''}
        {role === SUPER_ADMIN ? button('Organizations', ROUTES.ORGANIZATIONS, classes, pathname) : ''}
        {button('Devices', ROUTES.DEVICES, classes, pathname)}
        {expandableButton('Apps', classes, onAppsClick, appsOpen)}
        <Collapse in={appsOpen} timeout="auto" unmountOnExit>
            {subButton('Managed Apps', ROUTES.MANAGED_APPS, classes, pathname)}
            {subButton('External Apps', ROUTES.EXTERNAL_APPS, classes, pathname)}
        </Collapse>
        {role === SUPER_ADMIN || role === ADMIN ? button('Users', ROUTES.USERS, classes, pathname) : ''}
        {role === ADMIN ? button('Branding', ROUTES.BRANDING, classes, pathname) : ''}
        {role === ADMIN || role === SUPER_ADMIN ? button('API Keys', ROUTES.API_KEYS, classes, pathname) : ''}
        {actionButton('Logout', classes, onLogout)}
    </List>
);

const expandableButton = (text, classes, onClick, open) => (
    <ListItem key={text} button className={classes.button} onClick={onClick}>
        <ListItemText primary={text} />
        {open ? <ExpandMore /> : <ChevronRight />}
    </ListItem>
);

const button = (text, to, classes, pathname) => (
    <ListItem key={text} button className={pathname === to ? classes.buttonSelected : classes.button} component={Link} to={to}>
        <ListItemText primary={text} />
    </ListItem>
);

const actionButton = (text, classes, onLogout) => (
    <ListItem key={text} button className={classes.button} onClick={onLogout}>
        <ListItemText primary={text} />
    </ListItem>
);

const subButton = (text, to, classes, pathname) => (
    <ListItem key={text} button className={pathname === to ? classes.subButtonSelected : classes.subButton} component={Link} to={to}>
        <ListItemText primary={text} />
    </ListItem>
);

const useStyles = makeStyles((theme) => ({
    drawer: {
        backgroundColor: theme.palette.primary.main,
        height: '100%',
        width: theme.sizes.navBarWidth,
        paddingTop: '0px',
    },
    button: {
        color: theme.palette.textLight,
        width: '100%',
        '&:hover': {
            backgroundColor: theme.palette.navBarButton.hoverBG,
        },
    },
    buttonSelected: {
        color: theme.palette.textLight,
        backgroundColor: theme.palette.primary.light,
        width: '100%',
        '&:hover': {
            backgroundColor: theme.palette.primary.light,
        },
    },
    subButton: {
        color: theme.palette.textLight,
        paddingLeft: theme.spacing(4),
        width: '100%',
        '&:hover': {
            backgroundColor: theme.palette.navBarButton.hoverBG,
        },
    },
    subButtonSelected: {
        color: theme.palette.textLight,
        backgroundColor: theme.palette.primary.light,
        paddingLeft: theme.spacing(4),
        width: '100%',
        '&:hover': {
            backgroundColor: theme.palette.primary.light,
        },
    },
    topLogo: {
        width: theme.sizes.navBarWidth - theme.spacing(2),
        backgroundColor: theme.palette.primary.main,
        paddingTop: theme.spacing(2),
        padding: theme.spacing(1),
        borderBottom: `1px solid ${theme.palette.background.default}`,
    },
    bottomLogo: {
        width: theme.sizes.navBarWidth - theme.spacing(2),
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.textLight,
        paddingTop: theme.spacing(2),
        padding: theme.spacing(1),
        fontSize: '10px',
    },
    bottomLink: {
        lineHeight: 0,
        color: theme.palette.textLight,
        textDecoration: 'underline',
    },
}));
